var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulesInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "information-dark-icon.e4c0d26e2e7444ad3e0d41e4c9d1eb6e",
    d: "M61.5,56A5.5,5.5,0,1,0,67,61.5,5.5,5.5,0,0,0,61.5,56Zm0,2.255a.715.715,0,1,1-.715.715A.715.715,0,0,1,61.5,58.255Zm1.32,6.215H60.4a.44.44,0,0,1,0-.88h.77V61.17h-.44a.44.44,0,1,1,0-.88h.88a.44.44,0,0,1,.44.44v2.86h.77a.44.44,0,1,1,0,.88Z",
    transform: "translate(-56 -56)",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesInfoIcon);
export default __webpack_public_path__ + "static/media/rules-info-icon.9b4f2e01b1467a28c727d6dcb443fca7.svg";
export { ForwardRef as ReactComponent };